import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import NeighborhoodPage from './pages/NeighborhoodPage';
import GalleryPage from './pages/GalleryPage';
import AvailabilityPage from './pages/AvailabilityPage';
import ContactPage from './pages/ContactPage';

// Importation des polices Google Fonts
import { Helmet } from 'react-helmet';

const App: React.FC = () => {
  return (
    <Router>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Playfair+Display:wght@400;500;600;700&display=swap" rel="stylesheet" />
      </Helmet>
      <GlobalStyles />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/neighborhood" element={<NeighborhoodPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/availability" element={<AvailabilityPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
};

export default App;
